module.exports = __webpack_public_path__ + "static/img/logo02.2b310fb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo02.jpeg
// module id = vskT
// module chunks = 2